module.exports = __webpack_public_path__ + "img/user.4a4df1a2.svg";